export default function trimStr(word: any) {
  if (!word || typeof word !== "string") {
    return word;
  }

  return word.trim();
}

export function trimStrStart(word: any) {
  if (!word || typeof word !== "string") {
    return word;
  }

  return word.trim();
}
